export class EOFError extends Error {
  constructor(message = "End of input reached.") {
    super(message);
  }
}
